import React from 'react';
import { Card } from '../../../CommonComponents/OPL/Card/Card';

export const AsyncStateCard: React.FC = ({ children }) => {
  return (
    <Card
      width={640}
      height={438}
      display="flex"
      alignItems="center"
      justifyContent="center"
      mx="auto"
      mt={96}
    >
      {children}
    </Card>
  );
};
